"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var HeaderCell_1 = __importDefault(require("./HeaderCell"));
var Row_1 = __importDefault(require("./Row"));
var styles_1 = __importDefault(require("./styles"));
var Table = function (_a) {
    var className = _a.className, items = _a.items, columns = _a.columns, fallbackMessage = _a.fallbackMessage, style = _a.style;
    var headerCells = columns.map(function (x, i) { return react_1.default.createElement(HeaderCell_1.default, { key: i, column: x }); });
    var content = !!items.length
        ? items.map(function (x, i) { return (react_1.default.createElement(Row_1.default, { key: i, item: x, columns: columns, isHidden: x.isHidden, style: x.style, className: x.className })); })
        : react_1.default.createElement("span", { className: "fallback-message" }, fallbackMessage || 'No content provided');
    return (react_1.default.createElement(styles_1.default, { className: className, style: style },
        react_1.default.createElement("section", { className: "header" }, headerCells),
        react_1.default.createElement("section", { className: "content" }, content)));
};
exports.default = Table;
//# sourceMappingURL=index.js.map